import { Component, inject } from '@angular/core';

import { SurveyEditorService } from '../../../../services/survey-editor.service';

@Component({
  selector: 'empathy-info-settings',
  templateUrl: 'info-page-settings.component.html',
  styleUrls: ['./info-page-settings.component.scss']
})
export class InfoPageSettingsComponent {
  surveyEditorService = inject(SurveyEditorService);
}
